<template>
  <div>
    <b-form-group>
      <label>Ghi chú khách hàng:</label>
      <b-form-textarea
        v-model="orderNote.customerNote"
        size="sm"
        class="input-style"
        :placeholder="'Thêm ghi chú khách hàng'"
        :rows="6"
        :max-rows="6"
      ></b-form-textarea>
    </b-form-group>
    <b-form-group>
      <label>Ghi chú CR:</label>
      <b-form-textarea
        v-model="orderNote.saleNote"
        size="sm"
        class="input-style"
        :placeholder="'Thêm ghi chú CR'"
        :rows="6"
        :max-rows="6"
      ></b-form-textarea>
    </b-form-group>
    <b-form-group>
      <label>Ghi chú cửa hàng:</label>
      <b-form-textarea
        v-model="orderNote.storeNote"
        size="sm"
        class="input-style"
        :placeholder="'Thêm ghi chú cửa hàng'"
        :rows="6"
        :max-rows="6"
      ></b-form-textarea>
    </b-form-group>
    <b-form-group>
      <label>Ghi chú bảo hành:</label>
      <b-form-textarea
        v-model="orderNote.warrantyNote"
        size="sm"
        class="input-style"
        :placeholder="'Thêm ghi chú bảo hành'"
        :rows="6"
        :max-rows="6"
      ></b-form-textarea>
    </b-form-group>
    <b-form-group>
      <label v-if="checkCustomerCome()"> Ngày khách nhận hàng </label>
      <label v-else> Ngày đến cửa hàng: </label>

      <div class="input-group">
        <date-picker
          placeholder="Ngày đến cửa hàng"
          class="form-control-sm input-style"
          :config="dpConfigs.date"
          v-model="orderNote.checkDate"
          :wrap="true"
          :disabled="isCheckDateAndTimeDisabled"
        ></date-picker>
        <div class="input-group-append">
          <button
            class="btn btn-secondary btn-sm datepickerbutton"
            type="button"
            title="Toggle"
          >
            <i class="far fa-calendar"></i>
          </button>
        </div>
      </div>
    </b-form-group>
    <b-form-group>
      <label v-if="checkCustomerCome()"> Giờ khách nhận hàng</label>
      <label v-else> Giờ đến cửa hàng </label>
      <div class="input-group">
        <date-picker
          :config="dpConfigs.time"
          class="form-control-sm input-style"
          v-model="orderNote.checkTime"
          :wrap="true"
          placeholder="Giờ đến cửa hàng"
          :disabled="isCheckDateAndTimeDisabled"
        ></date-picker>
        <div class="input-group-append">
          <button
            class="btn btn-secondary btn-sm datepickerbutton"
            type="button"
            title="Toggle"
          >
            <i class="far fa-clock"></i>
          </button>
        </div>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SET_ORDER_NOTE_INFO } from '@/core/services/store/modules/order/order-note.module.js';
// Import datePicker component
import datePicker from 'vue-bootstrap-datetimepicker';
import timeUtils from '@/utils/date';

export default {
  mixins: [],
  props: ['data', 'action'],
  components: { datePicker },
  data() {
    return {
      orderNote: null,
      dpConfigs: null,
      originCheckDate: null,
      ORDER_TYPE: {
        BuyAtCounter: 1,
        PreOrder: 2,
        SelfDelivery: 3,
        Carrier: 4,
        Website: 5,
      },
    };
  },
  watch: {
    orderNote: {
      handler: function (value) {
        this.$store.dispatch(SET_ORDER_NOTE_INFO, value);
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters(['getOrderNote', 'getOrderInfo']),
    isCheckDateAndTimeDisabled() {
      if (this.action === 'update') {
        if (this.originCheckDate && this.originCheckDate) {
          return true;
        }
      }
      return false;
    },
  },
  created() {
    this.orderNote = this.getOrderNote;
    this.dpConfigs = timeUtils.DP_CONFIG;
    if (this.action === 'update') {
      if (this.getOrderInfo.checkDate && this.getOrderInfo.checkTime) {
        this.originCheckDate = this.getOrderInfo.checkDate;
        this.originCheckTime = this.getOrderInfo.checkTime;
      }
    }
  },
  methods: {
    checkCustomerCome() {
      return [this.ORDER_TYPE.SelfDelivery, this.ORDER_TYPE.Carrier].includes(
        Number(this.getOrderInfo.orderType),
      );
    },
  },
};
</script>
